import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Icon from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { ActionsWrapper, ItemLayoutBaseProps, layoutTypographyMixin, SelectedIcon } from './common';

export interface IconTwoLineItemLayoutProps extends ItemLayoutBaseProps {
  icon?: ReactNode;
  primaryText?: ReactNode;
  secondaryText?: ReactNode;
  actions?: ReactNode;
}

const Root = styled.div`
  ${layoutTypographyMixin('xs')};
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  ${Icon} {
    width: ${globalTheme.spacing.md};
    height: ${globalTheme.spacing.md};
    margin: ${globalTheme.spacing.sm};
  }
`;

const PrimaryTextWrapper = styled.div`
  ${layoutTypographyMixin('xs')};
`;
const SecondaryTextWrapper = styled.div`
  ${layoutTypographyMixin('xxs')};
`;

const VBox = styled.div``;

export const IconTwoLineLayout: FC<IconTwoLineItemLayoutProps> = ({
  actions,
  selectionVariant = 'solid',
  isSelected = false,
  showCheckIconWhenSelected = false,
  primaryText,
  secondaryText,
  icon,
}) => (
  <Root isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
    <IconWrapper>{icon}</IconWrapper>
    <VBox>
      <PrimaryTextWrapper isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
        {primaryText}
      </PrimaryTextWrapper>
      <SecondaryTextWrapper isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
        {secondaryText}
      </SecondaryTextWrapper>
    </VBox>
    {actions && <ActionsWrapper>{actions}</ActionsWrapper>}
    {isSelected && showCheckIconWhenSelected && <SelectedIcon />}
  </Root>
);
